package buildinfo

import scala.Predef._

/** This object was generated by sbt-buildinfo. */
case object sbtinfo {
  /** The value is "analytics". */
  val name: String = "analytics"
  /** The value is "1.0.15". */
  val version: String = "1.0.15"
  /** The value is "2.13.4". */
  val scalaVersion: String = "2.13.4"
  /** The value is "1.4.6". */
  val sbtVersion: String = "1.4.6"
  override val toString: String = {
    "name: %s, version: %s, scalaVersion: %s, sbtVersion: %s".format(
      name, version, scalaVersion, sbtVersion
    )
  }
}
